import { CFormSite } from '../site/site';
import { ISessionInfo } from './session.i';
import { CContactOverview } from '../contact/contact';

export class CSessionInfo implements ISessionInfo {
  is_accepted: boolean;
  id = 0;
  ref = '';
  postal = '';
  places = 0;
  debut: Date = null;
  fin: Date = null;
  site: CFormSite[] = [];
  responsable?: CContactOverview;

  constructor(source?: ISessionInfo) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        ref: source.ref,
        postal: source.postal,
        places: source.places,
        debut: source.debut,
        fin: source.fin,
        site: source.site ? [...source.site] : source.site,
        responsable: source.responsable
      });
    }
  }
}
